/**
 * Sichere Markdown-Hilfen für Leseansicht und Bildregeln (Paket 14).
 */

const HTTPS = /^https:\/\//i;

export function istSicheresBildUrl(url: string): boolean {
  return HTTPS.test(url.trim());
}

export function istRelativerBildPfad(url: string): boolean {
  const u = url.trim();
  if (!u) return false;
  if (/^[a-z][a-z0-9+.-]*:/i.test(u)) return false;
  return true;
}

export function bildSrcFuerAnzeige(url: string): {
  src: string | null;
  warnung: "relativ" | "unsicher" | null;
} {
  const u = url.trim();
  if (istSicheresBildUrl(u)) return { src: u, warnung: null };
  if (istRelativerBildPfad(u)) return { src: null, warnung: "relativ" };
  return { src: null, warnung: "unsicher" };
}
